import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const detail = {
  title: '天神咒',
  content: [
    '天神天神，<br />降临凡尘，',
    '护佑吾身，<br />赐福消灾，',
    '诚心所求，<br />必蒙感应。'
  ],
  description: '天神咒为祈求天神保佑之要咒，诚心诵读可获天神庇佑。',
  usage: [
    '每日起床后净手焚香诵读',
    '农历初一、十五为祈福吉日',
    '心中默念所求之事',
    '需心存善念，不可有恶念'
  ]
};

const FuzouDetail = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-cyan-50 to-blue-50 flex flex-col">
      <div className="flex-grow flex flex-col items-center py-12 px-4">
        <div className="w-full max-w-4xl">
          <button
            onClick={() => navigate('/fuzou')}
            className="flex items-center text-cyan-800 mb-8 hover:text-cyan-600 transition-colors"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            返回符咒列表
          </button>

          <div className="bg-white rounded-2xl shadow-xl border-2 border-cyan-200 overflow-hidden">
            <div className="bg-gradient-to-r from-cyan-500 to-blue-500 py-6 text-center">
              <h1 className="text-3xl font-bold text-white font-serif tracking-widest">
                {detail.title}
              </h1>
            </div>

            <div className="p-8">
              <p className="text-gray-600 mb-8 italic text-center">
                祈求天神保佑
              </p>

              <div className="space-y-4 text-xl sm:text-2xl font-medium text-gray-800 leading-relaxed font-serif text-center mb-10">
                {detail.content.map((line, index) => (
                  <p key={index} dangerouslySetInnerHTML={{ __html: line }}></p>
                ))}
              </div>

              <div className="space-y-6">
                <div className="bg-cyan-50 rounded-xl p-6 border border-cyan-100">
                  <h3 className="text-lg font-bold text-cyan-900 mb-3">咒语说明</h3>
                  <p className="text-gray-700">{detail.description}</p>
                </div>

                <div className="bg-cyan-50 rounded-xl p-6 border border-cyan-100">
                  <h3 className="text-lg font-bold text-cyan-900 mb-3">使用方法</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    {detail.usage.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FuzouDetail;
